import { useCallback, useState, useEffect } from 'react';

import { Popup } from 'common/popup';
import { Button, IconButton, TagButton } from 'common/buttons';

import { TagsModalProps } from './types';
import {
  Container,
  TopContainer,
  BottomContainer,
  ContentContainer,
} from './styles';

export const TagsModal = ({
  options,
  visible,
  onClose,
  onChange,
  selectedValues,
}: TagsModalProps) => {
  const [values, setValues] = useState<string[]>(selectedValues);

  useEffect(() => {
    setValues([...selectedValues]);
  }, [selectedValues]);

  const onTagClick = useCallback(
    (option: string) => {
      if (values.includes(option)) {
        setValues(values.filter((value) => value !== option));
        return;
      }
      setValues([...values, option]);
    },
    [values]
  );

  return (
    <Popup
      open={visible}
      closeOnEscape
      maxWidth="544px"
      onClose={onClose}
      closeOnDocumentClick
      position="center center"
    >
      <Container>
        <TopContainer>
          <h2>ADD TAG</h2>
          <IconButton icon="cross" onClick={onClose} />
        </TopContainer>

        <ContentContainer>
          {options.map((option) => (
            <TagButton
              title={option}
              key={`tag-button-${option}`}
              onClick={() => onTagClick(option)}
              isSelected={values.includes(option)}
            />
          ))}
        </ContentContainer>

        <BottomContainer>
          <Button
            title="Cancel"
            palette="white"
            variant="stroke"
            onClick={onClose}
          />
          <Button
            title="Add"
            variant="default"
            palette="primary"
            onClick={() => {
              if (onChange) onChange(values);
              onClose();
            }}
          />
        </BottomContainer>
      </Container>
    </Popup>
  );
};
